module.exports = __webpack_public_path__ + "img/szkola.76f2353e.jpg";